// The clinical system's patient page. One definition — it was written out in the
// payroll report and again in the patient drill, and a third copy was about to be
// added for the set-bonus screen.
//
// ⚠ This is PROD clinicui for every environment of ours, because there is one Xano
// behind both of its front-ends: pointing dev here is not a leak, it is simply the
// only place a patient card exists (see systems-map). The backend sends the same
// host for links it builds server-side, overridable per environment via SSM.
export const CLINICUI_PATIENT = 'https://clinicui.taliaz-cm.com/patient';

/** Deep link to a patient card, focused on one meeting when its id is known. */
export const clinicuiPatientLink = (internalId: number, meetingId = 0): string =>
  `${CLINICUI_PATIENT}?id=${internalId}${meetingId ? `&meeting_id=${meetingId}` : ''}`;
